/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import{MaskedColorDefinition as o,CreateMaskedFromUInt8NaNColor as e,MultiplyMaskedColors as r}from"./MaskedColor.glsl.js";import{glsl as l}from"../../shaderModules/glsl.js";function t(t,a){a.instancedColor?(t.attributes.add("instanceColor","vec4"),t.vertex.include(o),t.vertex.include(e),t.vertex.include(r),t.vertex.code.add(l`
      MaskedColor applyInstanceColor(MaskedColor color) {
        return multiplyMaskedColors( color, createMaskedFromUInt8NaNColor(${"instanceColor"}));
      }
    `)):t.vertex.code.add(l`MaskedColor applyInstanceColor(MaskedColor color) {
return color;
}`)}export{t as InstanceColor};
